import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { COMPRESSION_EXTENSIONS } from '../../services/BatchFileValidator';
import './ResultFileListItem.scss';

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f5',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const DocTooltip = ({ children, title, show }) => {
  if (!show) {
    return children;
  }
  return (
    <HtmlTooltip
      title={title}
    >
      {children}
    </HtmlTooltip>
  );
};

DocTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  show: PropTypes.bool,
};

DocTooltip.defaultProps = {
  title: undefined,
  show: true,
};

const ResultFileListItem = ({ file = {}, onCheck, onRemove, onCompressFileType, className, hideDescription, error }) => {
  const handleUseFileType = () => {
    onCheck(file, !file.use);
  };
  const handleCompressFileType = (event) => {
    onCompressFileType(file, event.target.value);
  };
  const handleRemove = () => {
    onRemove(file);
  };
  const labelId = `resultfile-label-${file.type.ext}`;
  return (
    <DocTooltip show={!hideDescription} title={file.type.description}>
      <ListItem
        role={undefined}
        dense
        button
        onClick={onCheck ? handleUseFileType : undefined}
        classes={{ container: classnames('grb-resultfile', className, error && 'grb-error') }}
      >
        {onCheck && (
          <ListItemIcon>
            <Checkbox
              checked={file.use}
              edge="start"
              tabIndex={-1}
              disableRipple
              inputProps={{ 'aria-labelledby': labelId, 'aria-label': 'result-filetype-checkbox' }}
            />
          </ListItemIcon>
        )}
        <ListItemText
          primary={file.type.ext.toUpperCase()}
          secondary={error || (!hideDescription && file.type.title || '')}
          // secondary={(
          //   <React.Fragment>
          //     <Typography
          //       component="span"
          //       variant="body2"
          //       color="textPrimary"
          //     >
          //       {file.type.title}
          //     </Typography>
          //   </React.Fragment>
          // )}
        />
        {(onCompressFileType || onRemove) && (
          <ListItemSecondaryAction>
            {onCompressFileType && (
              <div className="grbrsn-resultfile-compr-ctrn">
                <Typography variant="caption">Compression:</Typography>
                <TextField
                  select
                  className="grb-resultfile-compr"
                  value={file.compr}
                  onChange={handleCompressFileType}
                >
                  <MenuItem key="noCompression" value="none">None</MenuItem>
                  {COMPRESSION_EXTENSIONS.map(ext => (
                    <MenuItem key={ext} value={ext}>
                      {ext}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}
            {onRemove && (
              <IconButton aria-label="Delete" size="small" onClick={handleRemove}>
                <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  <path fill="none" d="M0 0h24v24H0z" />
                </svg>
              </IconButton>
            )}
          </ListItemSecondaryAction>
        )}
      </ListItem>
    </DocTooltip>
  );
};

ResultFileListItem.propTypes = {
  file: PropTypes.shape({}).isRequired,
  onCheck: PropTypes.func,
  onRemove: PropTypes.func,
  onCompressFileType: PropTypes.func,
  className: PropTypes.string,
  hideDescription: PropTypes.bool,
  error: PropTypes.string,
};

ResultFileListItem.defaultProps = {
  onCheck: undefined,
  onRemove: undefined,
  onCompressFileType: undefined,
  className: undefined,
  hideDescription: false,
  error: undefined,
};

export default ResultFileListItem;
